import { useState } from "react";
import logo from "../../Assets/images/logo.png";
import { Link, useNavigate } from "react-router-dom";
import { PasswordShowIcon } from "../../Assets/icons/PasswordShowIcon";
import { PasswordHideIcon } from "../../Assets/icons/PasswordHideIcon";
import { authService } from "../../services/authServices";
import { toast } from "react-toastify";

export const Signup = () => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    password: "",
    confirm_password: "",
  });

  const validateForm = () => {
    const newErrors = {};
    if (!formData.first_name.trim()) {
      newErrors.first_name = "First name is required";
    } else if (formData.first_name.length < 3) {
      newErrors.first_name = "First name must be at least 3 characters";
    }
    if (!formData.last_name.trim()) {
      newErrors.last_name = "Last name is required";
    } else if (formData.last_name.length < 3) {
      newErrors.last_name = "Last name must be at least 3 characters";
    }
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)
    ) {
      newErrors.email = "Invalid email format";
    }
    if (!formData.phone_number.trim()) {
      newErrors.phone_number = "Phone number is required";
    }
    if (!formData.password.trim()) {
      newErrors.password = "Password is required";
    } else if (formData.password !== formData.confirm_password) {
      newErrors.confirm_password = "Passwords do not match";
    }

    if (!formData.confirm_password.trim()) {
      newErrors.confirm_password = "Confirm Password is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const data = {
      first_name: formData.first_name,
      last_name: formData.last_name,
      email: formData.email,
      phone_number: formData.phone_number,
      password: formData.password,
    };

    setLoading(true);
    try {
      const response = await authService.signup(data);
      if (response.status === "ok" || response.code === 200) {
        navigate(`/otp-verification?email=${formData.email}&type=signup`);
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message?.[0]?.detail;
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="main min-vh-100 d-flex justify-content-center flex-row w-100 authmain">
        <div className="authcard">
          <div className="w-100 text-center">
            <Link to="" className="authlogo">
              <img src={logo} width={337} height={90} alt="logo" />
            </Link>
          </div>
          <div className="mt-5">
            <form className="authform pt-3" onSubmit={handleSubmit}>
              <div className="form-group mb-3 pb-1 d-flex gap-3">
                <div className="w-50">
                  <input
                    type="text"
                    name="first_name"
                    className="form-control"
                    placeholder="Enter First Name"
                    value={formData.first_name}
                    onChange={handleChange}
                  />
                  {errors.first_name && (
                    <span className="required-text">{errors.first_name}</span>
                  )}
                </div>

                <div className="w-50">
                  <input
                    type="text"
                    name="last_name"
                    className="form-control"
                    placeholder="Enter Last Name"
                    value={formData.last_name}
                    onChange={handleChange}
                  />
                  {errors.last_name && (
                    <span className="required-text">{errors.last_name}</span>
                  )}
                </div>
              </div>

              <div className="form-group mb-3 pb-1">
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  placeholder="Enter Email"
                  value={formData.email}
                  onChange={handleChange}
                />
                {errors.email && (
                  <span className="required-text">{errors.email}</span>
                )}
              </div>

              <div className="form-group mb-3 pb-1">
                <input
                  type="text"
                  name="phone_number"
                  className="form-control"
                  placeholder="Enter Phone Number"
                  value={formData.phone_number}
                  onChange={handleChange}
                />
                {errors.phone_number && (
                  <span className="required-text">{errors.phone_number}</span>
                )}
              </div>

              <div className="form-group password-group position-relative mb-3">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  className="form-control"
                  placeholder="Password"
                  value={formData.password}
                  onChange={handleChange}
                />
                <span
                  className="pswd-hide-show cursor-pointer"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <PasswordShowIcon /> : <PasswordHideIcon />}
                </span>
                {errors.password && (
                  <span className="required-text">{errors.password}</span>
                )}
              </div>

              <div className="form-group password-group position-relative mb-4">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirm_password"
                  className="form-control"
                  placeholder="Confirm Password"
                  value={formData.confirm_password}
                  onChange={handleChange}
                />
                <span
                  className="pswd-hide-show cursor-pointer"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? (
                    <PasswordShowIcon />
                  ) : (
                    <PasswordHideIcon />
                  )}
                </span>
                {errors.confirm_password && (
                  <span className="required-text">
                    {errors.confirm_password}
                  </span>
                )}
              </div>

              <button
                type="submit"
                className="btn-primary-custom w-100"
                disabled={loading}
              >
                {loading ? "Signing up..." : "Sign Up"}
              </button>
              <p className="text-center mt-4 white-font fw-medium h_5">
                Already have an account?{" "}
                <Link to="/login" className="font-12 fw-normal primary-font">
                  Sign In
                </Link>
              </p>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
